import { useState } from "react";
import { useTranslation } from "react-i18next";
import Spinner from "components/Spinner.jsx";
import {
  buildEditorSavePayload,
  isEditorFormChanged,
  openEditorDraft,
  saveEditorDraft,
} from "components/project/editorDraftUtils";

export default function EditorBtnBox({ props }) {
  const {
    form = {},
    setForm,
    prevData = null,
    setPrevData,
    isReadOnly,
    setIsReadOnly,
    type,
    user_id,
    project_id,
    setdata,
    refetch,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = async () => {
    setIsLoading(true);

    await saveEditorDraft(
      buildEditorSavePayload(
        {
          type,
          prevData,
          form,
          setForm,
          setPrevData,
          setIsReadOnly,
          setdata,
          user_id,
          project_id,
          refetch,
        },
        t,
      ),
    );

    setIsLoading(false);
  };

  const handleToggleEdit = () => {
    openEditorDraft({ form, setPrevData, setIsReadOnly });
  };

  return (
    <span className="editorBtnBox" onClick={(e) => e.stopPropagation()}>
      {isReadOnly && isEditorFormChanged(form, prevData) && (
        <button
          type="button"
          className="btn-bg-blue"
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {t("editorBtnBox.saveButton")}
        </button>
      )}

      <button
        type="button"
        className={!isReadOnly ? "btn-bg-blue" : "btn-bg-blue active"}
        onClick={handleToggleEdit}
        disabled={isLoading}
      >
        {isReadOnly
          ? t("editorBtnBox.cancelButton")
          : t("editorBtnBox.editButton")}
      </button>

      {isLoading && <Spinner />}
    </span>
  );
}
